import { Component } from "@angular/core";
import {
  FormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule
} from "@angular/forms";
import { MatFormField } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatToolbar } from "@angular/material/toolbar";
import { MatButton } from "@angular/material/button";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-job-editor",
  templateUrl: "./job-editor.component.html",
  styleUrls: ["./job-editor.component.css"],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatToolbar,
    MatButton,
    TranslatePipe
  ]
})
export class JobEditorComponent {
  public jobForm: UntypedFormGroup = new UntypedFormGroup({
    externalJobReference: new FormControl(""),
    externalPropertyReference: new FormControl("")
  });

  constructor() {}

  onCreateJob() {}
}
